//@ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BiCurrentLocation } from 'react-icons/bi';
import { getCurrentLocation, geocodeLatLng } from '../lib/utils';
import { Field } from 'formik';

interface MapWithAutoCompleteProps {
  showCurrentLocationButton?: boolean;
  showSearchInput?: boolean;
  showMap?: boolean;
  drag?: boolean;
  address: any; // Update the type of address as per your data structure
  setAddress: React.Dispatch<React.SetStateAction<any>>; // Update the type of setAddress as per your data structure
  setLatLng: React.Dispatch<React.SetStateAction<{ lat: number | string; lng: number | string }>>;
  latLng: { lat: number | string; lng: number | string };
}

export const MapWithAutoComplete = ({
  showCurrentLocationButton = false,
  showSearchInput = false,
  showMap = true,
  drag = true,
  address,
  setAddress,
  setLatLng,
  latLng,
  setFieldlatLng,
}) => {
  const [map, setMap] = useState<any>(null);
  const [marker, setMarker] = useState<any>(null);
  const [center, setCenter] = useState({
    lat: !isNaN(parseFloat(latLng?.lat)) ? parseFloat(latLng.lat) : 28.6105073,
    lng: !isNaN(parseFloat(latLng?.lng)) ? parseFloat(latLng.lng) : 77.1145653,
  });

  useEffect(() => {
    setCenter({
      lat: !isNaN(parseFloat(latLng?.lat)) ? parseFloat(latLng.lat) : 28.6105073,
      lng: !isNaN(parseFloat(latLng?.lng)) ? parseFloat(latLng.lng) : 77.1145653,
    });
  }, [latLng]);

  const mapRef = useRef<HTMLDivElement>(null);
  // const autoCompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const autoCompleteRef = useRef<any | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const LoadMap = useCallback(() => {
    const loadScript = (url, callback) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = url;
      script.addEventListener('load', callback);
      document.body.appendChild(script);
    };

    const initMap = () => {
      if (mapRef.current && !map) {
        //@ts-ignore
        setMap(new window.google.maps.Map(mapRef.current, {}));
      }
    };

    if (window?.google) {
      initMap();
    } else {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_AUTH_MAP}&libraries=places`,
        initMap
      );
    }
  }, []);

  useEffect(() => {
    LoadMap();
  }, [LoadMap]);

  useEffect(() => {
    if (map) {
      map.setOptions({ center, zoom: 15 });
      map.panTo(center);

      if (marker) {
        marker.setMap(null);
      }

      const newMarker = new window.google.maps.Marker({
        position: { ...center },
        map,
        draggable: true,
      });

      if (drag) setMarker(newMarker);
    }
  }, [map, center, drag]);

  // console.log(center)
  // console.log(latLng)
  useEffect(() => {
    if (map && marker) {
      marker?.addListener('dragend', async () => {
        const latlng = marker.getPosition();
        const lat = latlng.lat();
        const lng = latlng.lng();
        setCenter({ lat, lng });
        setLatLng({ lat, lng });
        setFieldlatLng && setFieldlatLng({ lat, lng });

        const geocoder = new window.google.maps.Geocoder();
        try {
          const results = await geocodeLatLng(geocoder, latlng);
          const stateComponent = results[0].address_components.find((component) =>
            component.types.includes('administrative_area_level_1')
          );
          const pincodeComponent = results[0].address_components.find((component) =>
            component.types.includes('postal_code')
          );

          setAddress((prev) => ({
            ...prev,
            state: stateComponent?.long_name || '',
            pincode: pincodeComponent?.long_name || '',
            latitude: lat.toString() || '',
            longitude: lng.toString() || '',
          }));
        } catch (error) {
          console.error(error);
        }
      });
    }
  }, [map, marker]);

  useEffect(() => {
    if (map) {
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current);
      autoCompleteRef.current.addListener('place_changed', async function () {
        const place = await autoCompleteRef.current.getPlace();
        const location = place.geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        const latlng = { lat, lng };
        setFieldlatLng && setFieldlatLng(latlng);
        const geocoder = new window.google.maps.Geocoder();

        try {
          const results = await geocodeLatLng(geocoder, latlng);
          const stateComponent = place.address_components.find((component) =>
            component.types.includes('administrative_area_level_1')
          );
          const pincodeComponent = place.address_components.find((component) =>
            component.types.includes('postal_code')
          );

          setAddress((prev) => ({
            ...prev,
            latitude: lat.toString() || '',
            longitude: lng.toString() || '',
            state: stateComponent?.long_name,
            pincode: pincodeComponent?.long_name,
            formattedAddress: place?.formatted_address,
            vicinity: place?.vicinity || '',
          }));
        } catch (error) {
          console.error(error);
        }

        setCenter({ lat, lng });
        setLatLng({ lat, lng });
      });
    }
  }, [map, setCenter, setAddress]);

  return (
    <div className="grid mt-4 md:grid-cols-1 grid-cols-1 w-full fex items-start gap-3  p-5 rounded-md  md:min-h-590 border border-r-slate-200 dark:border-slate-700">
      <div className="flex flex-col gap-2">
        <h4 className="w-full">
          Latitude: <span className="latlng">{latLng?.lat}</span>
        </h4>
        <h4 className="w-full">
          Longitude: <span className="latlng">{latLng?.lng}</span>
        </h4>

        {showCurrentLocationButton && (
          <button
            type="button"
            className="w-full btn btn-danger flex items-center justify-center"
            onClick={async () => {
              const getlatlng = await getCurrentLocation();
              setCenter(getlatlng);
              setLatLng(getlatlng);
              setFieldlatLng && setFieldlatLng(getlatlng);
              setAddress((prev) => ({
                ...prev,
                latitude: getlatlng?.lat || '',
                longitude: getlatlng?.lng || '',
              }));
            }}
          >
            <BiCurrentLocation /> current location
          </button>
        )}
      </div>
      <div className="w-full flex flex-col gap-2 ">
        {showSearchInput && (
          <input
            ref={inputRef}
            type="text"
            id="searchBox"
            className="w-full form-input"
            placeholder="Search for a location..."
          />
        )}
        {showMap && <div ref={mapRef} id="map" style={{ height: '300px', width: '100%' }}></div>}
      </div>
    </div>
  );
};

export default MapWithAutoComplete;
